const legalEntityKey = 'legal-entity'

export const legalEntityKeys = {
  list: [legalEntityKey, 'list'] as const,
}
